module.exports = __webpack_public_path__ + "media/images/icons/cloud-download-03f1185ec7fdb487b7a460749bf5b615.svg";